import React from 'react';
import s from './CapsuleTabList.scss';
import Link from '../../../Link/Link';

export const positions = { CENTER: 0, LEFT: 1, RIGHT: 2 };

export const getSubsetByIndex = (items, index) => {
  let startIndex = index;
  let endIndex = index + 3;
  if (index + 3 > items.length) {
    startIndex = items.length - 3;
    endIndex = items.length;
  }

  const subset = items.slice(startIndex, endIndex);

  return subset;
};

const CapsuleTabList = ({
  list,
  currentActiveTab,
  tabRefs,
  changeTabs,
  isWapView,
  cat = 'name',
  black = false
}) => (
  <div className={`${s.tabList} ${black ? s.black : ''} globalTabList`}>
    {list &&
      Array.isArray(list) &&
      list.map(
        (item, index) =>
          !item.hrefLink ? (
            <div
              key={index}
              ref={tabRefs[item[cat]]}
              onClick={() => {
                if (!isWapView) {
                  changeTabs(getSubsetByIndex(list, index));
                } else if (isWapView) {
                  changeTabs([list[index]]);
                }
              }}
              className={
                currentActiveTab &&
                currentActiveTab.some(obj => obj.name === item.name)
                  ? `${s.tabItem} ${s.active}`
                  : `${s.tabItem}`
              }
            >
              {item.name}
            </div>
          ) : (
            <Link
              key={index}
              to={item.hrefLink}
              className={
                // eslint-disable-next-line eqeqeq
                item.hrefLinkActive == 1
                  ? `${s.tabItem} ${s.active}`
                  : `${s.tabItem}`
              }
            >
              {item.name}
            </Link>
          ),
      )}
  </div>
);

export default CapsuleTabList;
